import { Box, Button, Theme, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

import { PayoutSummary, PayoutSummaryTab } from './types';

interface SummaryTabsProps {
  value: PayoutSummaryTab;
  summary: PayoutSummary;
  onChange: (value: PayoutSummaryTab) => void;
}

const useStyles = makeStyles()((theme: Theme) => ({
  container: {
    display: 'flex',
    gap: '8px',
    flexWrap: 'wrap',
    marginBottom: '16px',
  },
  tabButton: {
    borderRadius: '12px',
    border: `1px solid ${theme.palette.secondary.dark}`,
    padding: '10px 14px',
    textTransform: 'none',
    color: theme.palette.text.secondary,
    backgroundColor: theme.palette.primary.light,
    fontFamily: 'Inter',
    minWidth: 'fit-content',
  },
  activeTabButton: {
    color: theme.palette.common.white,
    borderColor: theme.palette.info.main,
    backgroundColor: 'rgba(0, 102, 124, 0.16)',
  },
  countText: {
    marginLeft: '8px',
    color: 'inherit',
    fontWeight: 600,
  },
}));

const SummaryTabs = ({ value, summary, onChange }: SummaryTabsProps) => {
  const { classes, cx } = useStyles();

  const tabs: Array<{ key: PayoutSummaryTab; label: string; count: number; hidden: boolean }> = [
    { key: 'needsAttention', label: 'Needs Attention', count: summary.needsAttention, hidden: false },
    { key: 'inProgress', label: 'In Progress', count: summary.inProgress, hidden: false },
    { key: 'completed', label: 'Completed', count: summary.completed, hidden: false },
    { key: 'all', label: 'All', count: summary.all, hidden: false },
  ];

  return (
    <Box className={classes.container} role="tablist" aria-label="Payout summary tabs">
      {tabs.map((tab) => (
        <Button
          key={tab.key}
          role="tab"
          aria-selected={value === tab.key}
          aria-label={tab.hidden ? tab.label : `${tab.label} ${tab.count}`}
          className={cx(classes.tabButton, value === tab.key && classes.activeTabButton)}
          onClick={() => onChange(tab.key)}
        >
          {tab.label}
          {!tab.hidden && (
            <Typography component="span" className={classes.countText}>
              ({tab.count})
            </Typography>
          )}
        </Button>
      ))}
    </Box>
  );
};

export default SummaryTabs;
